
export const modifyReturnScrollElement = (wCtx) => {
  return wCtx.document.querySelector("body")
}
